// Social Media Links Configuration — loaded from CMS-managed content
// (src/content/settings/social.json). Editors change these via the CMS at /admin.
// Leave a value empty ('') to hide that icon in the footer.
// Supported keys (icon is picked automatically in AppFooter):
// instagram, tiktok, snapchat, discord, facebook, twitter, youtube

import social from '@/content/settings/social.json';

export const SOCIAL_LINKS = social;
